import { Checkbox, Col, Form, Input, Row } from "antd";
import type React from "react";
import DatePicker from "@/components/ui/DatePicker";

const InvestigationsSection: React.FC = () => {
  return (
    <>
      <Form.Item label="Investigations" className="form-item checkbox-group-item">
        <Row gutter={24}>
          <Col>
            <Form.Item name="preOp1" valuePropName="checked" noStyle>
              <Checkbox className="checkbox-item">Pre-op 1</Checkbox>
            </Form.Item>
          </Col>
          <Col>
            <Form.Item name="preOp2" valuePropName="checked" noStyle>
              <Checkbox className="checkbox-item">Pre-op 2</Checkbox>
            </Form.Item>
          </Col>
          <Col>
            <Form.Item name="coagulationProfile" valuePropName="checked" noStyle>
              <Checkbox className="checkbox-item">Coagulation Profile</Checkbox>
            </Form.Item>
          </Col>
          <Col>
            <Form.Item name="ptptt" valuePropName="checked" noStyle>
              <Checkbox className="checkbox-item">PT/PTT</Checkbox>
            </Form.Item>
          </Col>
          <Col>
            <Form.Item name="fbc" valuePropName="checked" noStyle>
              <Checkbox className="checkbox-item">FBC</Checkbox>
            </Form.Item>
          </Col>
          <Col>
            <Form.Item name="uecrs" valuePropName="checked" noStyle>
              <Checkbox className="checkbox-item">U/E/Cr/S</Checkbox>
            </Form.Item>
          </Col>
          <Col>
            <Form.Item name="ecg" valuePropName="checked" noStyle>
              <Checkbox className="checkbox-item">ECG</Checkbox>
            </Form.Item>
          </Col>
          <Col>
            <Form.Item name="cxr" valuePropName="checked" noStyle>
              <Checkbox className="checkbox-item">CXR</Checkbox>
            </Form.Item>
          </Col>
          <Col>
            <Form.Item name="othersInvestigation" valuePropName="checked" noStyle>
              <Checkbox className="checkbox-item">Others</Checkbox>
            </Form.Item>
          </Col>
        </Row>
      </Form.Item>
      <Row gutter={16} className="form-row">
        <Col span={12}>
          <Form.Item
            label="Investigations / Others / Instructions"
            name="investigationsOthers"
            className="form-item"
          >
            <Input className="form-input" />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item
            label="Provisional Diagnosis"
            name="provisionalDiagnosis"
            className="form-item"
          >
            <Input className="form-input" />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item label="Date" name="date" className="form-item">
            <DatePicker format="DD MMM YYYY" style={{ width: "100%" }} className="date-picker" />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item label="Examined by Dr" name="examinedByDr" className="form-item">
            <Input className="form-input" />
          </Form.Item>
        </Col>
      </Row>
    </>
  );
};

export default InvestigationsSection;
